export enum PronunciationPosition {
  onTerm,
  onDefinition,
}
